<template>
  <div class="uk-container uk-margin-small-top">
    <h2 class="uk-heading-small uk-text-center">Manage Org Patterns</h2>
    <p class="uk-text-center uk-width-1-2@m uk-align-center">
      Manage the patterns shown in the org onboarding tool. You can add all of
      the product types at the same name, and edit patterns individually.
      Patterns are displayed alphabetically.
    </p>
    <div class="uk-width-1-1 uk-align-center">
      <div class="uk-child-width-1-3" uk-grid>
        <div></div>
        <div>
          <button
            class="uk-button uk-button-primary uk-margin-remove uk-width-1-1 uk-align-center"
            uk-toggle="target: #new-modal"
          >
            Add Pattern
          </button>
        </div>
        <div>
          <button
            class="uk-button uk-button-default uk-margin-remove uk-width-1-1 uk-align-center"
            uk-toggle="target: #manage-tags-modal"
          >
            Manage Tags
          </button>
        </div>
      </div>
    </div>

    <div id="stick-width" class="uk-align-center">
      <div
        class="uk-card uk-card-small uk-margin uk-card-default uk-card-body"
        uk-sticky=" bottom: #offset; width-element: #sticky-width; animation: uk-animation-slide-top; show-on-up: true;"
      >
        <ul uk-tab class="uk-flex-center uk-margin-remove-top">
          <li
            :class="{ 'uk-active': displayTies }"
            @click="setCurrentProductView('tie')"
          >
            <a href>Ties</a>
          </li>
          <li
            :class="{ 'uk-active': displayBowTies }"
            @click="setCurrentProductView('bowTie')"
          >
            <a href>Bow Ties</a>
          </li>
          <li
            :class="{ 'uk-active': displayPocketSquares }"
            @click="setCurrentProductView('pocketSquare')"
          >
            <a href>Pocket Squares</a>
          </li>
          <li
            :class="{ 'uk-active': displayInfinityScarves }"
            @click="setCurrentProductView('infinityScarf')"
          >
            <a href>Infinity Scarves</a>
          </li>
          <li
            :class="{ 'uk-active': displayChiffonScarves }"
            @click="setCurrentProductView('chiffonScarf')"
          >
            <a href>Chiffon Scarves</a>
          </li>
          <li
            :class="{ 'uk-active': displayHairScarves }"
            @click="setCurrentProductView('hairScarf')"
          >
            <a href>Hair Scarves</a>
          </li>
          <li
            :class="{ 'uk-active': displayKimonos }"
            @click="setCurrentProductView('kimono')"
          >
            <a href>Kimonos</a>
          </li>
          <li
            :class="{ 'uk-active': displayNeckGaiters }"
            @click="setCurrentProductView('neckGaiter')"
          >
            <a href>Neck Gaiters</a>
          </li>
          <li
            :class="{ 'uk-active': displaySuspenders }"
            @click="setCurrentProductView('suspenders')"
          >
            <a href>Suspenders</a>
          </li>
          <li
            :class="{ 'uk-active': displaySquarePillows }"
            @click="setCurrentProductView('squarePillow')"
          >
            <a href>Square Pillows</a>
          </li>
          <li
            :class="{ 'uk-active': displayLumbarPillows }"
            @click="setCurrentProductView('lumbarPillow')"
          >
            <a href>Lumbar Pillows</a>
          </li>
          <li
            :class="{ 'uk-active': displayTableRunners }"
            @click="setCurrentProductView('tableRunner')"
          >
            <a href>Table Runners</a>
          </li>
          <li
            :class="{ 'uk-active': displayFabricYardage }"
            @click="setCurrentProductView('fabricYardage')"
          >
            <a href>Fabric Yardage</a>
          </li>
          <li
            :class="{ 'uk-active': displayRobes }"
            @click="setCurrentProductView('robe')"
          >
            <a href>Robes</a>
          </li>
        </ul>
      </div>
    </div>

    <draggable
      v-model="displayedProducts"
      :force-fallback="true"
      group="products"
      class="uk-grid uk-child-width-1-2 uk-child-width-1-4@m"
      uk-grid
      @start="drag = true"
      @end="drag = false"
    >
      <div v-for="(pattern, key) in displayedProducts">
        <div
          id="card"
          :style="{ 'margin-bottom': '20px' }"
          class="uk-card uk-card-default uk-card-small"
        >
          <div class="uk-card-media-top">
            <img :src="pattern.image" alt />
          </div>
          <div class="uk-card-body">
            <h4 class="uk-card-title uk-margin-small-bottom">
              <center>{{ pattern.patternName }}</center>
            </h4>
            <p
              class="uk-margin-small-bottom uk-margin-remove-top uk-text-muted"
            >
              <center>{{ _.startCase(pattern.productType) }}</center>
            </p>
            <div
              v-if="patternTags(pattern).length"
              class="uk-text-center uk-margin-small-bottom"
            >
              <span
                v-for="tag in patternTags(pattern)"
                :key="tag.id"
                class="uk-label design-tag-chip"
              >
                {{ tag.name }}
              </span>
            </div>
            <button
              class="uk-button uk-button-default uk-margin-remove uk-width-1-1"
              @click="editPattern(key)"
            >
              Edit
            </button>
          </div>
        </div>
      </div>
    </draggable>

    <div id="edit-modal" uk-modal="esc-close: false; bg-close: false;">
      <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
        <button class="uk-modal-close-default" type="button" uk-close></button>
        <h2>Edit Pattern</h2>
        <img :src="editingPattern.image" class="uk-width-1-2" />
        <br />
        <div v-if="!uploading" class="js-upload uk-align-center" uk-form-custom>
          <input type="file" @change="onReplacementPicked" />
          <button
            class="uk-button uk-button-default uk-align-center"
            type="button"
            tabindex="-1"
          >
            <span
              v-if="!uploading"
              class="uk-margin-small-right"
              uk-icon="upload"
            ></span
            >Replace Image
          </button>
        </div>
        <button
          v-if="uploading"
          class="uk-button uk-button-default uk-align-center"
          type="button"
          tabindex="-1"
          disabled
        >
          <div uk-spinner></div>
          Uploading ({{ uploadProgress }}%)
        </button>
        <div class="uk-margin">
          <label class="uk-form-label" for="Name">Name</label>
          <div class="uk-form-controls">
            <input
              id="company"
              v-model="editingPattern.patternName"
              class="uk-input"
              type="text"
            />
          </div>
        </div>
        <div class="uk-margin">
          <label class="uk-form-label" for="Name">Type</label>
          <div class="uk-form-controls">
            <select v-model="editingPattern.productType" class="uk-select">
              <option>tie</option>
              <option>bowTie</option>
              <option>pocketSquare</option>
              <option>infinityScarf</option>
              <option>chiffonScarf</option>
              <option>hairScarf</option>
              <option>kimono</option>
              <option>neckGaiter</option>
              <option>suspenders</option>
              <option>squarePillow</option>
              <option>lumbarPillow</option>
              <option>tableRunners</option>
              <option>robe</option>
              <option>fabricYardage</option>
            </select>
          </div>
        </div>
        <design-tag-picker v-model="editingPattern.tags" :tags="designTags" />
        <div class="uk-width-1-1 uk-align-center">
          <div class="uk-child-width-1-2" uk-grid>
            <div>
              <button
                v-if="!preDelete"
                class="uk-button uk-button-danger uk-margin-remove uk-width-1-1"
                @click="activatePreDelete()"
              >
                Delete
              </button>
              <button
                v-if="preDelete"
                class="uk-button uk-button-danger uk-margin-remove uk-width-1-1"
                @click="deletePattern()"
              >
                Really Delete?
              </button>
            </div>
            <div>
              <button
                class="uk-button uk-button-primary uk-margin-remove uk-width-1-1"
                @click="updatePattern()"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      id="new-modal"
      class="uk-modal-container"
      uk-modal="esc-close: false; bg-close: false;"
    >
      <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
        <button class="uk-modal-close-default" type="button" uk-close></button>
        <h2>Add Pattern</h2>

        <div class="uk-margin">
          <label class="uk-form-label" for="Name">Pattern Name</label>
          <div class="uk-form-controls">
            <input
              v-model="newPattern.patternName"
              class="uk-input"
              type="text"
            />
          </div>
        </div>

        <design-tag-picker v-model="newPattern.tags" :tags="designTags" />

        <div class="uk-child-width-1-3" uk-grid>
          <div v-for="(image, productType) in newPattern.images">
            <div id="card" class="uk-card uk-card-default uk-card-small">
              <div class="uk-card-media-top">
                <img v-if="image" :src="image" alt />
                <img
                  v-if="!image"
                  src="../../assets/image-placeholder.jpg"
                  alt
                />
              </div>
              <div class="uk-card-body">
                <p
                  class="uk-margin-small-bottom uk-margin-remove-top uk-text-muted"
                >
                  <center>{{ _.startCase(productType) }}</center>
                </p>
                <div
                  v-if="!uploading"
                  class="js-upload uk-align-center"
                  uk-form-custom
                >
                  <input
                    type="file"
                    @change="newProductImagePicked(productType)"
                  />
                  <button
                    class="uk-button uk-button-default uk-align-center"
                    type="button"
                    tabindex="-1"
                  >
                    <span
                      v-if="!uploading"
                      class="uk-margin-small-right"
                      uk-icon="upload"
                    ></span
                    >Select a File
                  </button>
                </div>
                <button
                  v-if="uploading"
                  class="uk-button uk-button-default uk-align-center"
                  type="button"
                  tabindex="-1"
                  disabled
                >
                  <div uk-spinner></div>
                  Uploading
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="uk-width-1-1 uk-align-center">
          <div class="uk-child-width-1-2" uk-grid>
            <div></div>
            <div>
              <button
                class="uk-button uk-button-primary uk-margin-remove uk-width-1-1"
                @click="createNewPattern()"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <manage-tags-modal :tags="designTags" @changed="loadDesignTags" />
  </div>
</template>

<script>
import _ from "lodash";
import UIkit from "uikit";
import firebase from "firebase";
import draggable from "vuedraggable";
import ManageTagsModal from "./ManageTagsModal";
import DesignTagPicker from "./DesignTagPicker";
import { existingTagIds, resolveTags } from "@/utils/designTags";
import DesignTagsService from "@/services/DesignTagsService";

export default {
  name: "OrgPatternsAdmin",
  components: {
    draggable,
    ManageTagsModal,
    DesignTagPicker
  },
  data() {
    return {
      patterns: [],
      designTags: [],
      currentProductView: "tie",
      editingPattern: {},
      uploading: false,
      preDelete: false,
      newPattern: {
        patternName: "",
        tags: [],
        images: {
          tie: "",
          bowTie: "",
          pocketSquare: "",
          infinityScarf: "",
          chiffonScarf: "",
          hairScarf: "",
          kimono: "",
          neckGaiter: "",
          suspenders: "",
          squarePillow: "",
          lumbarPillow: "",
          tableRunners: "",
          robe: "",
          fabricYardage: ""
        }
      }
    };
  },
  computed: {
    displayedProducts: {
      get() {
        var self = this;
        var currentPatterns = [];
        for (const pattern of self.patterns) {
          pattern.productType == _.camelCase(self.currentProductView) &&
            currentPatterns.push(pattern);
        }
        currentPatterns.sort((a, b) => Number(a.index) - Number(b.index));
        return currentPatterns;
      },
      set(newOrder) {
        this.updatePatternOrder(newOrder).then(() => {
          // this.getPatterns()
        });
      }
    },
    displayTies() {
      return this.currentProductView == "tie";
    },
    displayBowTies() {
      return this.currentProductView == "bowTie";
    },
    displayPocketSquares() {
      return this.currentProductView == "pocketSquare";
    },
    displayInfinityScarves() {
      return this.currentProductView == "infinityScarf";
    },
    displayChiffonScarves() {
      return this.currentProductView == "chiffonScarf";
    },
    displayHairScarves() {
      return this.currentProductView == "hairScarf";
    },
    displayKimonos() {
      return this.currentProductView == "kimono";
    },
    displayNeckGaiters() {
      return this.currentProductView == "neckGaiter";
    },
    displaySuspenders() {
      return this.currentProductView == "suspenders";
    },
    displaySquarePillows() {
      return this.currentProductView == "squarePillow";
    },
    displayLumbarPillows() {
      return this.currentProductView == "lumbarPillow";
    },
    displayTableRunners() {
      return this.currentProductView == "tableRunners";
    },
    displayRobes() {
      return this.currentProductView == "robe";
    },
    displayFabricYardage() {
      return this.currentProductView == "fabricYardage";
    }
  },
  mounted: function() {
    if (this.$store.state.newOrgProject.selectedStyles.saved == true) {
      this.tempSelectedStyles = JSON.parse(JSON.stringify(this.selectedStyles));
    }
    this.getPatterns();
    this.loadDesignTags();
  },
  methods: {
    async loadDesignTags() {
      this.designTags = await DesignTagsService.list();
    },
    patternTags(pattern) {
      return resolveTags(pattern.tags, this.designTags);
    },
    setCurrentProductView(product) {
      this.currentProductView = product;
    },
    editPattern(key) {
      this.editingPattern = { tags: [], ...this.displayedProducts[key] };
      // this.getPatterns();
      this.preDelete = false;
      UIkit.modal("#edit-modal").show();
    },
    getPatterns() {
      var self = this;
      self.patterns = [];
      firebase
        .firestore()
        .collection("orgPatterns")
        .orderBy("patternName")
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            // doc.data() is never undefined for query doc snapshots
            let data = doc.data();
            data.id = doc.id;
            self.patterns.push(data);
          });
        });
    },
    async updatePattern() {
      await firebase
        .firestore()
        .collection("orgPatterns")
        .doc(this.editingPattern.id)
        .update({
          patternName: this.editingPattern.patternName,
          productType: this.editingPattern.productType,
          image: this.editingPattern.image,
          tags: existingTagIds(this.editingPattern.tags, this.designTags)
        });
      UIkit.modal("#edit-modal").hide();
      this.getPatterns();
    },
    async updatePatternOrder(newOrder) {
      const toUpdate = newOrder.filter(
        val => val.index !== newOrder.findIndex(v => v === val) + 1
      );
      for await (const pattern of toUpdate) {
        if (pattern.id) {
          pattern.index = newOrder.indexOf(pattern) + 1;
          await firebase
            .firestore()
            .collection("orgPatterns")
            .doc(pattern.id)
            .set(pattern);
        }
      }
    },
    async deletePattern() {
      await firebase
        .firestore()
        .collection("orgPatterns")
        .doc(this.editingPattern.id)
        .delete();
      UIkit.modal("#edit-modal").hide();
      this.getPatterns();
    },
    async createNewPattern() {
      const collection = firebase.firestore().collection("orgPatterns");
      const writes = [];
      for (const [productType, image] of Object.entries(
        this.newPattern.images
      )) {
        if (image) {
          const docRef = collection.doc();
          writes.push(
            docRef.set({
              id: docRef.id,
              image,
              patternName: this.newPattern.patternName,
              productType,
              tags: existingTagIds(this.newPattern.tags, this.designTags),
              index:
                this.patterns.filter(p => p.productType == productType).length +
                1
            })
          );
        }
      }
      await Promise.all(writes);
      this.getPatterns();
      UIkit.modal("#new-modal").hide();
      this.newPattern = {
        patternName: "",
        tags: [],
        images: {
          tie: "",
          bowTie: "",
          pocketSquare: "",
          infinityScarf: "",
          chiffonScarf: "",
          hairScarf: "",
          kimono: "",
          neckGaiter: "",
          suspenders: "",
          squarePillow: "",
          lumbarPillow: "",
          tableRunners: "",
          robe: ""
        }
      };
    },
    onReplacementPicked(event) {
      var self = this;
      const files = event.target.files;
      let filename = files[0].name;

      //firebase example
      let storageRef = firebase.storage().ref();
      let imageRef = storageRef.child("org-patterns/" + filename);
      let file = files[0];
      let uploadTask = imageRef.put(file);
      // Listen for state changes, errors, and completion of the upload.
      uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        function(snapshot) {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          let progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          self.uploadProgress = progress;
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              self.uploading = true;
              break;
          }
        },
        function(error) {
          console.error(error.code);
        },
        function() {
          // Upload completed successfully, now we can get the download URL
          uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            self.uploading = false;
            self.uploadProgress = 0;
            self.editingPattern.image = downloadURL;
          });
        }
      );
    },
    activatePreDelete() {
      this.preDelete = true;
    },
    newProductImagePicked(productType) {
      var self = this;
      const files = event.target.files;
      let filename = files[0].name;

      //firebase example
      let storageRef = firebase.storage().ref();
      let imageRef = storageRef.child("org-patterns/" + filename);
      let file = files[0];
      let uploadTask = imageRef.put(file);
      // Listen for state changes, errors, and completion of the upload.
      uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        function(snapshot) {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          let progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          self.uploadProgress = progress;
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              self.uploading = true;
              break;
          }
        },
        function(error) {
          console.error(error.code);
        },
        function() {
          // Upload completed successfully, now we can get the download URL
          uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            self.uploading = false;
            self.uploadProgress = 0;
            self.newPattern.images[productType] = downloadURL;
          });
        }
      );
    }
  }
};
</script>

<style type="text/css">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.design-tag-chip {
  margin: 0 3px 3px 0;
  text-transform: none;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/OrgPatternsAdmin.vue